import {createStore} from 'redux';
import rootReducer from '../Reducers';
import { loadState, saveState } from './localStorage';

//export default function configureStore(initialState) {
//	return createStore(rootReducer, initialState);
//}

const persistedState = loadState();
const store = createStore(rootReducer, persistedState);

store.subscribe(()=>{
	saveState(store.getState());
});

export default store;